export const isMfaFailure=result=>result.status==='failed';export const isMfaBusy=result=>result.status==='failed'&&result.error==='mfa_busy';